import { render, staticRenderFns } from "./QueueClinic.vue?vue&type=template&id=3e43bc92"
import script from "./QueueClinic.vue?vue&type=script&lang=js"
export * from "./QueueClinic.vue?vue&type=script&lang=js"
import style0 from "./QueueClinic.vue?vue&type=style&index=0&id=3e43bc92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports